import { Page } from "layouts/finance/shared";
import LabTabs from "./tab";
export default function Profile() {
  return (
    <Page
      title="Account settings"
      description="Manage your profile, business information, and account security."
    >
      <LabTabs />
    </Page>
  );
}
